/* eslint-disable react-hooks/exhaustive-deps */
import { LoadingOutlined } from '@ant-design/icons';
import CardSectionHeader from '@components/CardSectionHeader';
import { useReviewState } from '@core/configureStore';
import { StarRating } from '@core/models';
import { Card } from 'antd';
import React, { useMemo } from 'react';

type Props = {};

const NegativeReviewWidget = (props: Props) => {
  const { reviewResponse, isLoading: isLoadingReview } = useReviewState();
  const negativeRatingReviews: number[] = useMemo(
    () =>
      (reviewResponse.reviews || [])
        .map(review => parseInt(StarRating[review?.starRating.valueOf()]) as number)
        .filter(rating => rating < 3) || [],
    [reviewResponse]
  );
  return (
    <Card className="no-padding" style={{ padding: '0px', borderRadius: 10 }}>
      <div style={{ padding: '15px 15px' }}>
        <CardSectionHeader title="Negative Reviews" />
        {isLoadingReview ? (
          <LoadingOutlined />
        ) : (
          <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between' }}>
            <h3 style={{ fontSize: 14, margin: 0 }}>{negativeRatingReviews.length || 0}</h3>
            <p>1 to 2 stars reviews</p>
          </div>
        )}
      </div>
    </Card>
  );
};

export default NegativeReviewWidget;
